<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <v-btn text color="secondary" v-on="on">
            More Links...
            <v-icon right>mdi-link</v-icon>
          </v-btn>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
      <div class="actionBlock">
        <v-btn text color="secondary" v-on="on" @click="info = !info">
          Overview
          <v-icon right>mdi-file-document-box</v-icon>
        </v-btn>
      </div>
    </div>
    <v-navigation-drawer temporary clipped fixed right hide-overlay v-model="info" width="400">
      <gl-acct-no-info :updateCnt="$store.state.glAcctParam.glAcctNo.updateCnt"></gl-acct-no-info>
    </v-navigation-drawer>
    <v-card>
      <!-- <v-card-title>
        <span class="title">{{glacctNoId.branch}} {{glacctNoId.glacctNo}} {{glacctNoId.fund}} {{glacctNoId.acctNoSfx}}</span>
      </v-card-title> -->
      <transition name="slide-x-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import GlAcctNoInfo from '../GLAcctNoInfo'
export default {
  data() {
    return {
      title: 'GL Account No',
      breadcrumb: [],
      sideMenu: [
        { name: 'glAcctNoDetQuery', text: 'GL Account No.' },
        { name: 'glPostAcctQuery', text: 'GL Ledger' },
        { name: 'glBudgetQuery', text: 'GL Budget' }
      ],
      sideFunction: [
        {
          text: 'GL Account No.',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'glAcctNoDetQuery' }
        },
        {
          text: 'GL Ledger',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'glPostAcctQuery' }
        }
      ],
      info: false
    }
  },
  created() {
    this.breadcrumb = this.derieveBreadcrumbByName('glAcctNoList')
    this.breadcrumb.push({
      text: this.title
    })
  },
  mounted() {
    this.doInit()
  },
  methods: {
    doInit() {}
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    glacctNoId() {
      return this.$store.state.glAcctParam.glAcctNo.glAcctNoId
    }
  },
  components: {
    SideFunctionMenu,
    GlAcctNoInfo
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/base.scss';
.queryPnl {
  margin-top: 50px;
}
</style>
